import {
  ArticleImageGallery as ArticleImageGalleryUI,
  IArticleImageProps,
} from "@business-finland/wif-ui-lib/dist/ArticleImageGallery";
import { useTranslation } from "next-i18next";

import { Viewport } from "../../../constants/app";
import useImageDataHandler, {
  ImageDataHandlerFn,
} from "../../../hooks/useImageDataHandler";
import { jcrMultiFieldToArray } from "../../../util/magnolia";

interface IArticleImageProp {
  image: Wif.Mgnl.Image;
  caption?: string;
  altText?: string;
}

interface IArticleImageGalleryProps {
  images: Wif.Mgnl.NodeWithList<Wif.Mgnl.Node<IArticleImageProp>>;
}

export function ArticleImageGallery(
  props: IArticleImageGalleryProps
): JSX.Element {
  const { t } = useTranslation();
  const imageDataHandler = useImageDataHandler();
  const imageNodes = jcrMultiFieldToArray(props.images);
  const images = imageNodes.map((node) =>
    mapImageNodeToArticleImage(node, imageDataHandler)
  );

  return (
    <ArticleImageGalleryUI images={images} creditsLabel={t("assets.credits")} />
  );
}

function mapImageNodeToArticleImage(
  node: Wif.Mgnl.Node<IArticleImageProp>,
  imageDataHandler: ImageDataHandlerFn
): IArticleImageProps {
  const { image, caption, altText } = node;

  const imageData = imageDataHandler(image, { maxViewport: Viewport.sm });
  const title = image.metadata?.title;

  return {
    ...imageData,
    caption,
    credits: image?.metadata?.rights,
    altText: altText || title || caption || "Image",
  };
}
